<template>
    <div class="social-media-icon">
        <IconLinkInstagram v-if="name === 'instagram'" :link="link" />
        <IconLinkLinkedIn v-if="name === 'linkedIn'" :link="link" />
        <IconLinkFacebook v-if="name === 'facebook'" :link="link" />
    </div>
</template>

<script setup lang="ts">
    // To make icons accessible, we followed this ressource:
    // https://www.sarasoueidan.com/blog/accessible-icon-buttons/#technique-%232%3A-accessible-visually-hidden-text-with-hidden-and-aria-labelledby

    import IconLinkFacebook from './icon-link/Facebook.vue';
    import IconLinkInstagram from './icon-link/Instagram.vue';
    import IconLinkLinkedIn from './icon-link/LinkedIn.vue';

    withDefaults(
        defineProps<{
            name?: 'twitter' | 'instagram' | 'linkedIn' | 'facebook';
            link: string;
        }>(),
        {
            name: 'linkedIn',
        },
    );
</script>

<style lang="scss" scoped>
    .social-media-icon {
        g,
        path {
            transition: all var(--joy-transition-duration-default) var(--joy-transition-timing-function);
            stroke: var(--joy-color-neutral-50);
        }

        &:hover {
            g,
            path {
                fill: var(--color-neutral-grey);
            }
        }
    }
</style>
